import type { ComponentProps } from "react";
import { use, useState } from "react";
import { LuSave } from "react-icons/lu";

import { DIALOG, setDialog } from "@/components/app/dialogs/dialog-provider";
import { saveDraft } from "@/components/app/editor-v3/draft-utils";
import { Button } from "@/components/ui/button";
import {
  DropdownDrawer,
  DropdownDrawerContent,
  DropdownDrawerItem,
  DropdownDrawerTrigger,
} from "@/components/ui/dropdown-drawer";
import { UserContext } from "@/contexts/user-context";

import { useEditorContext } from "../editor-context";

export const EditorActionDraft = ({
  children,
  ...props
}: ComponentProps<typeof Button>) => {
  const {
    body,
    gatedBody,
    media,
    gatedMedia,
    poll,
    setEditorContext,
    subscriptionTier,
  } = useEditorContext();
  const { currentUserPublicKey } = use(UserContext);
  const [open, setOpen] = useState(false);

  return (
    <DropdownDrawer
      historyName="editor-draft-actions"
      onOpenChange={setOpen}
      open={open}
      title="Drafts"
    >
      <DropdownDrawerTrigger
        render={
          <Button
            size="icon"
            variant="outline"
            className="relative rounded-full text-muted"
            {...props}
          >
            <LuSave className="text-lg" />
            {children}
          </Button>
        }
      />
      <DropdownDrawerContent>
        <DropdownDrawerItem
          onClick={() => {
            saveDraft(
              currentUserPublicKey,
              {
                body,
                gatedBody,
                media,
                gatedMedia,
                poll,
              },
              subscriptionTier,
              false,
            );
          }}
        >
          Save as Draft
        </DropdownDrawerItem>
        <DropdownDrawerItem
          closeOnClick={false}
          onClick={() => {
            setDialog(DIALOG.DraftManager, {
              open: true,
              historyMode: "entry",
              replace: true,
              props: {
                currentUserPublicKey,
                onLoadDraft: (draftData) => {
                  setEditorContext(draftData);
                },
              },
            });
            setOpen(false);
          }}
        >
          Load Drafts
        </DropdownDrawerItem>
      </DropdownDrawerContent>
    </DropdownDrawer>
  );
};
